import styled from 'styled-components';

export const InfographicFrame = styled.img`
  width: 100%;
  max-width: 24rem;
  min-height: 10rem;
`;
